import {
	createTurnAction,
	createStateCondition,
	createStateChangedTrigger,
} from '../../common/stateManagement.js';
import { createPowerLevelCondition, createPowerThresholdTrigger } from '../../common/powerMonitoring.js';

/**
 * Triple Relay Template (Gen2+ RPC API)
 * Supports devices with 3 independent relay channels
 * Uses Switch.Set RPC method for control
 */
export function createTriRelayTemplate() {
	return {
		deviceType: 'tri_relay',
		channels: ['switch:0', 'switch:1', 'switch:2'],
		actions: {
			turn: createTurnAction('Switch.Set', 'on'),
		},
		conditions: {
			isOn: createStateCondition('output'),
		},
		triggers: {
			stateChanged: createStateChangedTrigger('output'),
		},
	};
}

/**
 * Triple Relay with Power Monitoring Template (Gen2+ RPC API)
 * Adds power monitoring capabilities to tri-relay template
 */
export function createTriRelayPMTemplate() {
	return {
		deviceType: 'tri_relay_pm',
		channels: ['switch:0', 'switch:1', 'switch:2'],
		actions: {
			turn: createTurnAction('Switch.Set', 'on'),
		},
		conditions: {
			isOn: createStateCondition('output'),
			powerLevel: createPowerLevelCondition(3680),
		},
		triggers: {
			stateChanged: createStateChangedTrigger('output'),
			powerThreshold: createPowerThresholdTrigger(),
		},
	};
}
